/* Copyright 2018 The MathWorks, Inc. */

/**
 * The gallery popup can be rendered in list view in several ways: Default, compact.
 */
define([], function () {
    return {
        DEFAULT: "default",
        COMPACT: "compact"
    };
        // COMFORTABLE: "comfortable",
        // CARD: "card"
});